import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import moment from "moment";
import { saveAs } from 'file-saver';

// import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from '../../common/components/Header';
import Nav from '../../common/components/Nav';
import Footer from '../../common/components/Footer';
import Pagination from "../../common/components/Pagination";
import ScrollReveal from "../../common/components/ScrollReveal";

import './search-dataset.css'

import { searchDataset } from "../../utils/api/dataset";
// import { setDataSetToVisualize } from '../../store/actions/actions/survey';
import { errorHandler } from "../../utils/helpers/errorHandler";
// import DownloadApp from "../../common/components/DownloadApp";


const SearchDatasetPage = () => {
  const SIZE_PER_PAGE = `${process.env.REACT_APP_SIZE_PER_PAGE}` === "undefined"
    ? 20 : `${process.env.REACT_APP_SIZE_PER_PAGE}`;

  const searchParams = useSelector(state => state.search);

  const history = useHistory();
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState(searchParams.query);
  const [monthValue, setMonthValue] = useState(undefined);
  const [datasetSurveyResult, setDatasetSurveyResult] = useState([]);
  const [year, setYear] = useState(moment(new Date()).format("YYYY"));

  const [hasSearched, setHasSearched] = useState(!!searchParams.query);
  const [selectedValue, setSelectedValue] = useState(""); // for the dropdown value



  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(SIZE_PER_PAGE);

  useEffect(() => {
    if (searchParams.query) {
      setSearchText(searchParams.query);
      setHasSearched(true);
    }
  }, [searchParams.query]);

  useEffect(() => {
    advancedSearch();
  }, []);


  const handleSearch = async (searchQuery) => {
    try {
      const data = await searchDataset(searchQuery);

      setPage(data.page);
      setMaxPage(data.count);
      setDatasetSurveyResult(data.allDatasets);
    } catch (error) {
      errorHandler(error, toast);
    }
  }

  useEffect(() => {
    var x, i, j, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    for (i = 0; i < x.length; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < selElmnt.length; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
          var y, i, k, s, h;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          h = this.parentNode.previousSibling;
          for (i = 0; i < s.length; i++) {
            if (s.options[i].innerHTML === this.innerHTML) {
              s.selectedIndex = i;
              const event = new Event('change');
              selElmnt.dispatchEvent(event)
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              for (k = 0; k < y.length; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
      });
    }
    function closeAllSelect(elmnt) {
      var x, y, i, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      for (i = 0; i < y.length; i++) {
        if (elmnt === y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    document.addEventListener("click", closeAllSelect);
  }, []);

  const advancedSearch = async (page = 0, queryOverride = null) => {
    try {
      const searchQuery = queryOverride ?? searchText.trim();

      const searchParams = {
        query: searchQuery,
        month: monthValue,
        year,
        page,
        // Add category parameter for backend filtering
        category: searchQuery.toLowerCase()
      };

      const validSearchKeys = [];

      for (let key in searchParams) {
        if (searchParams[key]) {
          // For category, we need to map the display name to the backend value
          if (key === 'category') {
            const categoryMap = {
              'education': 'education',
              'health': 'health',
              'economic affairs': 'economic affairs',
              'public order safety': 'public order safety',
              'general public service': 'general public service',
              'environmental protection': 'environmental protection',
              'housing and community amenities': 'housing and community amenities',
              'social protection': 'social protection',
              'recreation culture and religion': 'recreation culture and religion'
            };
            
            const backendCategory = categoryMap[searchParams[key].toLowerCase()];
            if (backendCategory) {
              validSearchKeys.push(`${key}=${backendCategory}`);
            }
          } else {
            validSearchKeys.push(`${key}=${searchParams[key]}`);
          }
        }
      }

      await handleSearch(validSearchKeys);
    } catch (error) {
      errorHandler(error, toast);
    }
  }
  

  const handleAdvanceSearch = async (event) => {
    event.preventDefault();
    setSearchText(selectedValue); // updates state for UI
    setHasSearched(true);
    await advancedSearch(0, selectedValue); // explicitly pass the latest query
  }
    

  const handleFileDownload = async (file, name) => {
    try {
      const fileName = file.substr(file.lastIndexOf('/') + 1);

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/publications/${fileName}/download/`,
        {
          headers: { 'Content-Type': 'application/json' }
        });

      const blob = await res.blob()
      saveAs(blob, name);
    } catch (error) {
      errorHandler(error, toast);
    }
  }

  const handleNextPagination = async (event) => {
    event.preventDefault();
    await advancedSearch(+page);
  }

  const handlePreviousPagination = async (event) => {
    event.preventDefault();
    await advancedSearch(page - 2);
  }

  const getIconForTitle = (title = '', file = '') => {
    const combined = `${title} ${file}`.toLowerCase();
    if (combined.includes('xlsx') || combined.includes('xls') || combined.includes('excel')) return 'fa-file-excel-o';
    if (combined.includes('pdf')) return 'fa-file-pdf-o';
    if (combined.includes('csv')) return 'fa-file-text-o';
    if (combined.includes('doc') || combined.includes('docx')) return 'fa-file-word-o';
    if (combined.includes('json')) return 'fa-file-code-o';
    if (combined.includes('zip') || combined.includes('rar')) return 'fa-file-archive-o';
    return 'fa-database';
  };

  const getFormatBadge = (file = '') => {
    if (!file) return 'Data';
    const ext = file.split('.').pop().toLowerCase();
    if (ext === 'xlsx' || ext === 'xls') return 'Excel';
    if (ext === 'pdf') return 'PDF';
    if (ext === 'csv') return 'CSV';
    if (ext === 'doc' || ext === 'docx') return 'Word';
    if (ext === 'json') return 'JSON';
    if (ext === 'zip' || ext === 'rar') return 'ZIP';
    return ext ? ext.toUpperCase() : 'Data';
  };

  return (
    <>
      <header>
        <Nav />
        {/* Hero Section */}
        <ScrollReveal>
          <section
            style={{
              background: "linear-gradient(135deg, #0C9EA9 0%, #076f78 100%)",
              padding: "80px 0 60px",
            }}
          >
            <div className="container text-center text-white">
              <span
                style={{
                  display: "inline-block",
                  background: "rgba(255,255,255,0.15)",
                  borderRadius: "20px",
                  padding: "4px 16px",
                  fontSize: "12px",
                  fontWeight: "600",
                  letterSpacing: "1.2px",
                  marginBottom: "16px",
                  textTransform: "uppercase",
                }}
              >
                Open Data Search
              </span>
              <h1
                className="fw-bold mb-3"
                style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)" }}
              >
                Explore Data
              </h1>
              <p
                className="mb-4"
                style={{ opacity: 0.85, maxWidth: "560px", margin: "0 auto 24px" }}
              >
                Explore and download datasets filtered by your search criteria.
              </p>
              <div
                className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill"
                style={{ background: "rgba(255,255,255,0.15)" }}
              >
                <span style={{ fontSize: "1.4rem", fontWeight: "700" }}>
                  {datasetSurveyResult.length}
                </span>
                <span style={{ opacity: 0.85, fontSize: "0.9rem" }}>
                  Dataset{datasetSurveyResult.length !== 1 ? "s" : ""} Available
                </span>
              </div>
            </div>
          </section>
        </ScrollReveal>

        <div className="bg-light border-bottom py-3">
          <div className="container">
            <p className="mb-0 text-center">
              You searched for {hasSearched && `“${searchText}”`}
            </p>

            <div
              className="__formdiv __serchfmdiv mt-3"
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <form>
                <div className="input-group" >
                  <select 
                    required
                    className="form-control __ekoform"
                    placeholder="Search for information"
                    value={selectedValue}
                    onChange={(event) => {
                      setSelectedValue(event.target.value);
                      setHasSearched(false); // Clear previous search
                    }}
                    >
                    <option value="" selected disabled>Search for information</option>
                    <option value="Education">Education</option>
                    <option value="Health">Health</option>
                    <option value="Economic Affairs">Economic Affairs</option>
                    <option value="public order safety">Public Order & Safety</option>
                    <option value="general public service">General Public Service</option>
                    <option value="environmental protection">Environmental Protection</option>
                    <option value="housing and community amenities">Housing and community Amenities</option>
                    <option value="social protection">Social Protection</option>
                    <option value="recreation culture and religion">Recreation, Culture and Religion</option>
                  </select>
                  
                  <span className="input-group-btn">
                    <button
                      className="btn __ekoformbtn"
                      type="submit"
                      onClick={handleAdvanceSearch}
                    >
                      Search
                    </button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </header>

      <section style={{ background: "#ffffff" }}>
        <div className="container py-5">
          {datasetSurveyResult.length > 0 ? (
            <div className="d-flex flex-column gap-4">
              {datasetSurveyResult.map((data, idx) => {
                const icon = getIconForTitle(data.name, data.file);
                const format = getFormatBadge(data.file);
                const hasFile = data.file;

                return (
                  <ScrollReveal key={`${data.name}-${idx}`} className="w-100">
                    <div
                      className="card border-0 shadow-sm rounded-4 bg-white position-relative"
                      style={{
                        borderLeft: "4px solid #0C9EA9",
                        transition: "transform 0.25s ease, box-shadow 0.25s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-6px)";
                        e.currentTarget.style.boxShadow = "0 16px 40px rgba(0,0,0,0.13)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "";
                      }}
                    >
                      <div className="card-body p-4 d-flex gap-4">
                        <div
                          className="d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "12px",
                            background: "#f0fafa",
                            color: "#0C9EA9",
                          }}
                        >
                          <i className={`fa ${icon} fa-lg`} />
                        </div>

                        <div className="d-flex flex-column flex-grow-1 w-100">
                          <h5 className="fw-bold text-dark mb-2">{data.name}</h5>
                          <div className="mb-3">
                            <span
                              className="badge rounded-pill px-3 py-1"
                              style={{
                                background: "#f0fafa",
                                color: "#0C9EA9",
                                fontWeight: "600",
                                fontSize: "0.75rem",
                              }}
                            >
                              {format}
                            </span>
                          </div>
                          <div
                            className="text-black small mb-3"
                            dangerouslySetInnerHTML={{
                              __html: data.description,
                            }}
                          />
                          {hasFile && (
                            <button
                              onClick={(event) => {
                                event.preventDefault();
                                handleFileDownload(data.file, data.name);
                              }}
                              className="btn text-white rounded-2 fw-semibold mt-auto align-self-start"
                              style={{
                                backgroundColor: "#0C9EA9",
                                border: "none",
                                padding: "8px 20px",
                              }}
                            >
                              <i className="fa fa-download me-2"></i> Download Data
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </ScrollReveal>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-5">
              <h4 className="text-dark fw-bold">No search results</h4>
              <p className="text-muted">
                There are no datasets matching your search at the moment.
              </p>
            </div>
          )}

          <div className="__expmia1i mt-4">
            <div className="container">
              <Pagination
                page={+page}
                maxPage={+maxPage}
                SIZE_PER_PAGE={+SIZE_PER_PAGE}
                handleNextPagination={handleNextPagination}
                handlePreviousPagination={handlePreviousPagination}
              />
            </div>
          </div>
        </div>
      </section>
      <ToastContainer closeOnClick pauseOnHover />
      <Footer />
    </>
  );
};

export default SearchDatasetPage;